import Call from "@material-ui/icons/Call";
import Block from "@material-ui/icons/Block";
import Domain from "@material-ui/icons/Domain";
import PeopleAlt from "@material-ui/icons/PeopleAlt";
import Accessible from "@material-ui/icons/Accessible";
import CalendarToday from "@material-ui/icons/CalendarToday";
import DesktopWindows from "@material-ui/icons/DesktopWindows";

export const items = [
    {
        href: "/locais-de-atendimento",
        label: "Locais de Atendimento",
        icon: Domain,
        allowedRoles: [
            "Administrador de Atendimento",
            "Gerente de Atendimento",
            "Coordenador de Atendimento",
        ]
    },
    {
        href: "/totens",
        label: "Totem",
        icon: DesktopWindows,
        allowedRoles: [
            "Administrador de Atendimento",
            "Gerente de Atendimento",
        ]
    },
    {
        href: "/prioridades",
        label: "Prioridades",
        icon: Accessible,
        allowedRoles: [
            "Administrador de Atendimento",
        ]
    },
    {
        href: "/atendentes",
        label: "Atendentes",
        icon: Call,
        allowedRoles: [
            "Administrador de Atendimento",
            "Gerente de Atendimento",
            "Coordenador de Atendimento",
        ]
    },
    {
        href: "/usuarios",
        label: "Usuários",
        icon: PeopleAlt,
        allowedRoles: [
            "Administrador de Atendimento",
            "Gerente de Atendimento",
            "Coordenador de Atendimento"
        ]
    },
    {
        href: "/cancelamentos",
        label: "Cancelamentos",
        icon: Block,
        allowedRoles: [
            "Administrador de Atendimento",
            "Gerente de Atendimento",
        ]
    },
    {
        href: "/reagendamentos",
        label: "Reagendamentos",
        icon: CalendarToday,
        allowedRoles: [
            "Administrador de Atendimento",
            "Gerente de Atendimento",
        ]
    },
];
